<form class="flex flex-wrap gap-2 pb-6" [formGroup]="form">
  <div class="flex w-full flex-col gap-4 md:flex-row">
    <app-form-field class="w-full">
      <label app-label translate>geral.titulo</label>
      <input app-input [placeholder]="'geral.titulo' | translate" formControlName="title" />
    </app-form-field>

    <app-form-field class="w-full md:w-36">
      <label app-label translate>eclass.aula.destacar</label>
      <app-switch [formControl]="pinnedCtrl"></app-switch>
    </app-form-field>

    @if (!!isLegacy() && !!pinnedCtrl.value) {
      <app-form-field class="w-full md:w-52">
        <label app-label translate>eclass.aula.fixar-ate</label>
        <app-input-datepicker
          [minDate]="date$ | async"
          [weekend]="false"
          formControlName="date_pin"
        ></app-input-datepicker>
      </app-form-field>
    }
  </div>

  <app-form-field class="w-full">
    <label app-label translate>geral.descricao</label>
    <app-text-editor
      class="block"
      [url]="textEditorUrl"
      [toolbar]="toolbar"
      formControlName="content"
    ></app-text-editor>
  </app-form-field>

  <app-attachment-dropzone
    class="w-full mt-4 block"
    [maxSizeMB]="config.maxFilesize"
    [accept]="config.acceptedFiles"
    [multiple]="config.maxFiles > 1"
    [maxFiles]="config.maxFiles"
    folder="dailies"
    [downloadable]="true"
    [previewable]="true"
    [initialAttachments]="existingAttachments"
    (uploadComplete)="onUploaded($event)"
    (filesChanged)="onFilesChanged($event)"
    (removeExisting)="onFileRemoved($event)"
  ></app-attachment-dropzone>
</form>
